import utils from '../libs/utils';
import axios from './axios';

const MODULE_NAME = 'v1/erp-base-web';
export default {
  axios,
  assetsPlanList(params) { //
    return axios.post(`${MODULE_NAME}/asserts/curing/list/condition`, utils.exchangeParams(params));
  },

  assetsList(params) {
    return axios.post(`${MODULE_NAME}/asserts/list/condition`, utils.exchangeParams(params));
  },
  // typeList(params) { // 设备类型
  //   return axios.post(`${MODULE_NAME}/asserts/type/list/condition`, utils.exchangeParams(params));
  // },

  assetsAddDetails(params) { // 录入设备
    return axios.post(`${MODULE_NAME}/asserts/edit`, utils.exchangeParams(params));
  },

  assetsSave(params) { //   保存设备
    return axios.post(`${MODULE_NAME}/asserts/add`, utils.exchangeParams(params));
  },

  assetsUpdate(params) { //  更新设备
    return axios.post(`${MODULE_NAME}/asserts/update`, utils.exchangeParams(params));
  },

  assetsInfo(params) { // 查看设备详情
    return axios.post(`${MODULE_NAME}/asserts/detail`, utils.exchangeParams(params));
  },

  assetsCarringForward(params) { // 生成结转凭证
    return axios.post(`${MODULE_NAME}/asserts/carrying/forwards/add`, utils.exchangeParams(params));
  },

  isAssertsCodeExist(params) {
    return axios.post(`${MODULE_NAME}/asserts/code/exist`, utils.exchangeParams(params));
  },

  isAssertsTypeNameExist(params) {
    return axios.post(`${MODULE_NAME}/asserts/type/name/exist`, utils.exchangeParams(params));
  },

  assertsTypeAdd(params) { // 录入设备类型
    return axios.post(`${MODULE_NAME}/asserts/type/add`, utils.exchangeParams(params));
  },

  assertsTypeUpdate(params) { // 录入设备类型
    return axios.post(`${MODULE_NAME}/asserts/type/update`, utils.exchangeParams(params));
  },

  typeList(params) {
    return axios.post(`${MODULE_NAME}/asserts/type/list/condition`, utils.exchangeParams(params));
  },

  addPlan(params) {
    return axios.post(`${MODULE_NAME}/asserts/curing/plan/add`, utils.exchangeParams(params));
  },

  planList(params) {
    return axios.post(`${MODULE_NAME}/asserts/curing/plan/list/condition`, utils.exchangeParams(params));
  },

  planDetail(params) {
    return axios.get(`${MODULE_NAME}/asserts/curing/plan/detail?${utils.exchangeParams(params)}`);
  },

  savePlan(params) {
    return axios.post(`${MODULE_NAME}/asserts/curing/result/add`, utils.exchangeParams(params));
  },

  submitPlan(params) {
    return axios.post(`${MODULE_NAME}/asserts/curing/result/submit`, utils.exchangeParams(params));
  },

  assertsTypeEditUpdate(params) { // 录入设备类型编辑
    return axios.post(`${MODULE_NAME}/asserts/type/edit`, utils.exchangeParams(params));
  },
};
